import React from "react";
import { RiDeleteBin6Line } from "react-icons/ri";
import axiosInstance from "../services/axiosInstance";
import { Navigate, useNavigate } from "react-router-dom";
import { PopUps } from "../enums/Constants";

const DeleteOrderPopup = ({
  user,
  userList,
  setUserList,
  openPopUp,
  closePopUp,
  orderId,
}) => {
  const navigate = useNavigate();

  const RefreshPage = () => {
    closePopUp();
  };

  const deleteOrder = async () => {
    await axiosInstance.post(`/api/Order/deleteOrder?orderId=${orderId}`);
    navigate("/dashboard");
    closePopUp();
  };

  if (openPopUp !== true) return null;

  return (
    <div
      id="ModelContainer"
      className="fixed inset-0 bg-black flex justify-center items-center bg-opacity-20 backdrop-blur-sm"
    >
      <div className="relative bg-blue-400 w-5/6 xl:w-[400px] 3xl:w-[600px]  text-center mx-auto rounded-[30px] p-10 pt-14 shadow-[0_0_7px_rgba(92,92,92,0.35)] drop-shadow-[0_0_4px_rgba(178,178,178,0.2)">
        <div className="w-full xl:w-4/5 text-center mx-auto">
          <div className="flex flex-col items-center space-y-6">
            <div className="bg-gray-200 p-4 rounded-full flex items-center justify-center">
              <RiDeleteBin6Line className="text-[#EE120A] text-6xl" />
            </div>
            <h2 className="font-robotoBold text-gray-800 py-5 3xl:py-7 text-center text-3xl 3xl:text-4xl">
              {PopUps.DELETE_ORDER_POPUP}
            </h2>
            <div className="flex space-x-4">
              <button
                className="bg-white text-blue uppercase text-2xl xl:text-base 3xl:text-2xl border border-blue hover:bg-blue-800 hover:border-blue-800 hover:text-white font-robotoBold py-2 px-5 rounded-lg focus:outline-none focus:shadow-outline transition-all ease-in leading-relaxed"
                type="button"
                onClick={RefreshPage}
              >
                Abbrechen
              </button>
              <button
                className="bg-blue uppercase text-2xl xl:text-base 3xl:text-2xl border border-blue hover:bg-blue-800 hover:border-blue-800 text-white font-robotoBold py-2 px-5 rounded-lg focus:outline-none focus:shadow-outline transition-all ease-in leading-relaxed"
                type="button"
                onClick={deleteOrder}
              >
                Ja
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteOrderPopup;
